// extracted by mini-css-extract-plugin
export default {"popoverItem":"popoverItem--PlGgN","folderIcon":"folderIcon--vxOsS","trigger":"trigger--CABOh","active":"active--et4pB"};